import {
  tagColumnNames as mainTagColumns,
  TagColumnNames as MainTagColumns,
} from 'pages/admin/files';
import {
  columnNames as mainColumnNames,
  ColumnNames as MainColumnNames,
  Columns as MainColumns,
  initialActiveColumns as mainInitialActiveColumns,
} from 'pages/admin/files/index-components/DocumentationFileList';
import { List } from 'store/actions/admin/documentationFileLists';
import ActionTypes from 'store/actionTypes/admin/documentationFileLists';
import { ListState } from 'store/reducers/types';
import { updateObject } from 'store/updateObject';
import Tags from 'types/Tags';
import {
  isColumns,
  isNumberAction,
  isStringAction,
  isTagsAction,
  TypedAction,
} from 'types/typeguards/reducerActions';

export type DocumentationFileListsState = {
  main: ListState<MainTagColumns, MainColumns, 'asc/'>;
};

const initialState: DocumentationFileListsState = {
  main: {
    page: 0,
    tags: {
      role: [],
    },
    search: '',
    activeColumns: mainInitialActiveColumns,
    take: 100,
    order: 'asc/',
  },
};

const setPage = (
  list: List,
  state: DocumentationFileListsState,
  action: TypedAction<number>,
) => {
  return updateObject(state, {
    [list]: updateObject(state[list], {
      page: action.value,
    }),
  });
};

const setSearch = (
  list: List,
  state: DocumentationFileListsState,
  action: TypedAction<string>,
) => {
  return updateObject(state, {
    [list]: updateObject(state[list], {
      search: action.value,
      page: 0,
    }),
  });
};

const setMainTags = (
  state: DocumentationFileListsState,
  action: TypedAction<Tags<MainTagColumns>>,
) => {
  return updateObject(state, {
    main: updateObject(state.main, {
      tags: action.value,
      page: 0,
    }),
  });
};

const setMainActiveColumns = (
  state: DocumentationFileListsState,
  action: TypedAction<MainColumns>,
) => {
  return updateObject(state, {
    main: updateObject(state.main, {
      activeColumns: action.value,
    }),
  });
};
const setTake = (
  list: List,
  state: DocumentationFileListsState,
  action: TypedAction<number>,
) => {
  return updateObject(state, {
    [list]: updateObject(state[list], {
      take: action.value,
      page: 0,
    }),
  });
};

const documentationFileListsReducer = (
  state = initialState,
  action: { type: string; value: unknown },
) => {
  switch (action.type) {
    // Main
    case ActionTypes.MAIN_SET_PAGE:
      if (isNumberAction(action)) {
        return setPage('main', state, action);
      }
      console.log('Action type error: setPage');
      return state;

    case ActionTypes.MAIN_SET_SEARCH:
      if (isStringAction(action)) {
        return setSearch('main', state, action);
      }
      console.log('Action type error: setSearch');
      return state;

    case ActionTypes.MAIN_SET_TAGS:
      if (isTagsAction<MainTagColumns>(mainTagColumns, action)) {
        return setMainTags(state, action);
      }
      console.log('Action type error: setTags');
      return state;

    case ActionTypes.MAIN_SET_ACTIVE_COLUMNS:
      if (isColumns<MainColumnNames>(mainColumnNames, action)) {
        return setMainActiveColumns(state, action);
      }
      console.log('Action type error: setActiveColumns');
      return state;

    case ActionTypes.MAIN_SET_TAKE:
      if (isNumberAction(action)) {
        return setTake('main', state, action);
      }
      console.log('Action type error: setTake');
      return state;

    default:
      return state;
  }
};

export default documentationFileListsReducer;
